import React from "react";

import { Header } from "../../components/Header";
// import { useTranslation } from "react-i18next";
// import { Helmet } from "react-helmet";
import "./styles.less";
import { KeyClockProblem } from "../../blocks/solution-keycloak-problem";
import { KeyClockEnterprise } from "../../blocks/solution-keyclock-enterprise";
import { KeyClockTable } from "../../blocks/solution-keyclock-table";
import { KeyClockCompare } from "../../blocks/solution-keyclock-compare";
import { SolutionKeycloakBanner } from "../../blocks/solution-keycloak-banner";
import { SolutionConsult } from "../../blocks/common-solution-consult";
import { Footer } from "../../components/Footer";
// import { CommonLinkPage } from "../../blocks/common-link-page";
// import { useTranslation } from "react-i18next";

export const KeyclockPage = () => {
  // const { t } = useTranslation();
  // const pagesLink = [
  //   {
  //     title: t("common.pageLink.okta.title"),
  //     description: t("common.pageLink.okta.description"),
  //     imgurl: "/page-link-solution-replace-okta.png",
  //     jumpLink: "/solutions/okta",
  //   },
  //   {
  //     title: t("common.pageLink.keycloak.title"),
  //     description: t("common.pageLink.keycloak.description"),
  //     imgurl: "/page-link-solution-keycloak.png",
  //     jumpLink: "/solutions/keycloak",
  //   },

  //   {
  //     title: t("common.pageLink.wechat.title"),
  //     description: t("common.pageLink.iam.description"),
  //     imgurl: "/page-link-solution-wechat.png",
  //     jumpLink: "/solutions/wechat",
  //   },
  // ];
  return (
    <div className="keyclock-page">
      <Header mode="light" />
      <SolutionKeycloakBanner />
      <KeyClockProblem />
      <KeyClockEnterprise />
      <KeyClockTable />
      <KeyClockCompare />
      {/* <CommonLinkPage pagesLink={pagesLink} /> */}
      <SolutionConsult />
      <Footer />
    </div>
  );
};
